import { api, endpoints } from "api/api";
import { AxiosPromise } from "axios";
import { CourseTermsFormValues } from "components/templates/AddTermsModal/CreateTermsForm";
import { UpdateTermsFormValues } from "components/templates/AddTermsModal/UpdateTermsForm";

const fetchTerms = (categoryId: number): AxiosPromise<{ terms: CategoryTermApi[] }> => {
  return api.get<{ terms: CategoryTermApi[] }>(endpoints.CATEGORIES_TERMS.GET_TERMS(categoryId));
};

const create = (courseId: number, body: CourseTermsFormValues): AxiosPromise<number> => {
  const formData = new FormData();

  // @ts-expect-error - file type
  formData.append("terms", body.terms[0] as File);
  formData.append("name", body.name);
  formData.append("description", body.description ?? "");
  return api.post<number>(endpoints.CATEGORIES_TERMS.CREATE(courseId), formData);
};

const update = (courseId: number, categoryTermsId: number, body: UpdateTermsFormValues): AxiosPromise<void> => {
  return api.put<void>(endpoints.CATEGORIES_TERMS.UPDATE(courseId, categoryTermsId), body);
};
const deleteResource = (courseId: number, categoryTermsId: number): AxiosPromise<void> => {
  return api.delete<void>(endpoints.CATEGORIES_TERMS.DELETE(courseId, categoryTermsId));
};

export const categoriesTermsApi = {
  fetchTerms,
  create,
  update,
  deleteResource,
};

export interface CategoryTermApi {
  id: number;
  name: string;
  description: string;
  link: string;
}
